import { IconButton, Label } from '@localina/core';
import { ArrowLeftIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ITitleProps {
    value: string;

    subtitle?: string;
    icon?: React.ReactNode;
    onBack?: () => void;
    tooltip?: string;
    actions?: React.ReactNode;
}

export const PageTitle: React.FC<ITitleProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="page-title">
            {}
            <div className="page-title__content">
                {props.onBack && (
                    <IconButton
                        className="page-title__content__button"
                        icon={<ArrowLeftIcon />}
                        onClick={props.onBack}
                        ariaLabel={t('core:buttons.back')}
                    />
                )}
                <div className="page-title__content__text">
                    <div className="page-title__content__title">
                        {props.icon}
                        <Label type="title" value={props.value} variant="h5" tooltip={props.tooltip} />
                    </div>
                    {Boolean(props.subtitle) && (
                        <Label type="info" value={props.subtitle} extraClassName="page-title__content__subtitle" />
                    )}
                </div>
                {props.actions && <div className="page-title__content__actions">{props.actions}</div>}
            </div>
        </div>
    );
};
